var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('big-map',{ref:"bigmap",attrs:{"code":"new_pipe_network_legend"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }